// extracted by mini-css-extract-plugin
var _1 = "default-fXI79";
var _2 = "danger-UQ09Q";
var _3 = "primary-l4QsT";
var _4 = "selected-I3TY9";
var _5 = "spin-ZOAJU";
var _6 = "spinner-KAicc";
var _7 = "success-w2aSH";
var _8 = "warning-L3Q2G";
export { _1 as "_default", _2 as "danger", _3 as "primary", _4 as "selected", _5 as "spin", _6 as "spinner", _7 as "success", _8 as "warning" }
